import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { useStateWithDeps } from "use-state-with-deps";
import { renderClose, useSimpleDialog } from "../../common/dialog";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propEnumField, propTinyMceEditor } from "../../common/entityStoreForm";
import { usePrintTemplates } from "../../common/enum";
import { UseListStore } from "../../common/listStore";
import { customerOrderDialogTitle, useCustomerBasicInfo } from "./common";
import { CustomerDto, OrderListItem } from "./types";
import { createAxios } from "../../common/axios";

export const PrintDialog = (props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    useOrderListStore: UseListStore<OrderListItem>;
}) => {
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const { order, isFetchingOrders } = props.useOrderListStore(p => ({
        order: p.selectedItem != null ? p.selectedItem : p.items.at(0),
        isFetchingOrders: p.fetching,
    }));

    const [useTemplateSelectStore] = useState(() => createEntityStore<{ printTemplateId?: number }>({ data: {} }));
    const printTemplateId = useTemplateSelectStore(p => p.clientData.printTemplateId);

    const simpleDialog = useSimpleDialog();
    const [useTemplateStore] = useStateWithDeps(() => createEntityStore<PrintTemplate>({
        path: printTemplateId == null ? undefined : "customers/customerPrint", qs: {
            customerId: customer.id,
            orderId: order?.id,
            printTemplateId,
        }, data: { warnings: [] },
        onServerDataChanged(entity) {
            if (entity.warnings.length > 0) {
                simpleDialog.show("Warnings", entity.warnings.join("\n"));
            }
        },
    }), [customer.id, order?.id, printTemplateId]);

    return <>
        {simpleDialog.render()}
        <DialogTitle>{customerOrderDialogTitle(order?.ordId, isFetchingOrders, () => "Print letter", customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={12}>{propEnumField(useTemplateSelectStore)("printTemplateId", "Print template", usePrintTemplates)}</Grid>
                <Grid item xs={12}>{propTinyMceEditor(useTemplateStore)("text", "Content", {
                    logPrint() {
                        if (printTemplateId != null) {
                            createAxios().post("history", {
                                type: "Letter sent",
                                description: usePrintTemplates.getState().items.find(p => p.id === printTemplateId)?.name,
                                customerId: customer.id,
                            });
                        }
                    }
                })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};

interface PrintTemplate {
    text?: string;
    warnings: string[];
}
